import "./SlidesTable.css";

import { useTable, useSortBy, useExpanded } from "react-table";
import { useSticky } from "react-table-sticky";

import { AdminSlideList } from "pwapi";

import SlidesColumns from "./SlidesColumns";
import SlidesTableView from "./SlidesTableView";

export interface SlidesTableProps {
  columns?: any; // TODO: Remove `any`
  // TODO: in general, proper typing across react-table
  slides?: AdminSlideList[];
  slideEditUrl?: string;
}

const SlidesTable = ({ columns, slides }: SlidesTableProps) => {
  const { headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: slides || [],
      autoResetExpanded: false,
      autoResetSortBy: false,
      defaultColumn: {
        sortDescFirst: true,
      },
      initialState: {
        sortBy: [
          {
            id: "label",
            desc: false,
          },
        ],
      },
    },
    useSortBy,
    useExpanded,
    useSticky
  );

  return (
    <SlidesTableView
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
    />
  );
};

export default SlidesColumns(SlidesTable, { showPrintLabels: true });
